import { languages, ILanguage } from "../common/languages";

export const langCodeExists = (code: string = ""): boolean => {
  const lang = getLanguageByCode(code);
  return lang ? true : false;
};

export const getLanguageNameByCode = (code: string = ""): string => {
  const language = getLanguageByCode(code);
  return language ? language.name : "";
};

export const getLanguageByCode = (code: string = ""): ILanguage | undefined =>
  languages.find(
    (language: any) =>
      language.code.toLocaleLowerCase() === code.toLocaleLowerCase()
  );
